<template>
  <div>
    <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
      <div class="single container-max page-content">
        <div class="row position-relative">
          <div class="col-12 mt-3 mt-md-5 d-flex justify-content-between align-items-md-center">
            <div class="d-flex align-items-center flex-wrap flex-xl-nowrap mb-2">
              <h1 class="h2 title d-inline-block" data-testing="item-name">
                <span>
                  {{ currentVariation | itemName }}
                </span>
              </h1>
              <div v-if="currentVariation.item.condition.id == 1" class="condition special-tags d-inline-block ml-xl-2">
                <span class="badge badge-bundle bg-info">
                  {{ $translate("babyVueTheme::Catview.Condition") }}
                </span>
              </div>
            </div>

            <div class="manufacturer ml-3" v-if="hasGroupId143 || currentVariation.filter.hasManufacturer">
              <!-- Kibella spezifische Anzeige -->
              <template v-if="hasGroupId143 && propertyGroupList.some((property) => property.id == 407 && property.values.value == 'Kibella')">
                <a href="https://www.babyshoppen.de/kibella">
                  <img src="https://cdn02.plentymarkets.com/xk05oz0zb09e/frontend/Herstellerlogos/kibella_logo_150x75.png" alt="Kibella" class="img-fluid" />
                </a>
              </template>
              <!-- Babyshoppen spezifische Anzeige -->
              <template v-else-if="hasGroupId143 && propertyGroupList.some((property) => property.id == 407 && property.values.value == 'Babyshoppen')">
                <a href="https://www.babyshoppen.de/babyshoppen">
                  <img src="https://cdn02.plentymarkets.com/xk05oz0zb09e/frontend/Herstellerlogos/babyshoppen_logo_150x75.png" alt="Babyshoppen" class="img-fluid" />
                </a>
              </template>

              <!-- Allgemeine Herstelleranzeige -->
              <template v-else-if="currentVariation.filter.hasManufacturer">
                <a v-if="currentVariation.item.manufacturer.url != ''" :href="currentVariation.item.manufacturer.url">
                  <img v-if="currentVariation.item.manufacturer.logo != ''" :alt="currentVariation.item.manufacturer.externalName" :src="currentVariation.item.manufacturer.logo" class="img-fluid" />
                  <p v-else v-html="currentVariation.item.manufacturer.externalName"></p>
                </a>
                <div v-else>
                  <img v-if="currentVariation.item.manufacturer.logo != ''" :alt="currentVariation.item.manufacturer.externalName" :src="currentVariation.item.manufacturer.logo" class="img-fluid" />
                  <p v-else v-html="currentVariation.item.manufacturer.externalName"></p>
                </div>
              </template>
            </div>
          </div>

          <div class="col-12 col-md-6 mb-3">
            <slot name="image-carousel"></slot>
          </div>

          <div class="col-12 col-md-6 col-lg-6 offset-xl-1 col-xl-5">
            <div>
              <!-- START SINGLEITEM_DETAILS -->

              <div class="d-none">
                <slot name="tag-list"></slot>
              </div>

              <template v-if="hasGroupId143">
                <ul class="add-data my-4 list-unstyled py-5 px-4 p-lg-5">
                  <template v-for="property in propertyGroupList" v-if="property.id != 311 && property.id != 312">
                    <li class="mb-3 d-flex align-items-center">
                      <i aria-hidden="true" class="fa fa-check mr-3"></i>
                      <span class="name font-weight-bold mr-1">{{ property.names.name }}: </span>
                      <span v-if="property.values.value != null" class="value">{{ property.values.value }}</span>
                      <template v-else>
                        <div class="value" v-if="">
                          <span v-for="(multiprop, index) in property.values" v-if="multiprop != null" class="multi d-block">{{ multiprop.value }}</span>
                        </div>
                      </template>
                    </li>
                  </template>
                </ul>
              </template>

              <!-- Variation -->
              <div v-if="attributes.length || Object.keys(units).length" class="mb-3">
                <variation-select></variation-select>
              </div>
              <!-- /Variation -->

              <!-- Item Bundle -->
              <item-bundle
                v-if="currentVariation.variation.bundleType === 'bundle'"
                :bundle-components="currentVariation.bundleComponents"
                :bundle-type="currentVariation.variation.bundleType"
              ></item-bundle>
              <!-- /Item Bundle -->

              <slot name="before-price"></slot>

              <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                <order-property-list></order-property-list>
              </div>

              <graduated-prices></graduated-prices>

              <item-price :show-cross-price="isRecommendedPriceActive"></item-price>

              <template v-for="tag in currentVariation.tags" v-if="tag.id == 15">
                <p class="font-weight-bold">{{ $translate("babyVueTheme::Single.Spedition") }}</p>
              </template>

              <span class="vat small text-muted mb-3 d-block">
                {{ $translate("Ceres::Template.singleItemFootnote1") }} <template v-if="showNetPrices">{{ $translate("Ceres::Template.singleItemExclVAT") }}</template
                ><template v-else>{{ $translate("Ceres::Template.singleItemInclVAT") }}</template> {{ $translate("Ceres::Template.singleItemExclusive") }}
                <a v-if="hasShippingCostsCategoryId" data-toggle="modal" href="#shippingscosts">{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>
                <a v-else :title="$translate('Ceres::Template.singleItemShippingCosts')">{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>
              </span>

              <slot name="after-price"></slot>

              <div class="d-flex justify-content-between align-items-center">
                <item-availability></item-availability>

                <div v-if="isWishListEnabled" class="fs-wishlist">
                  <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
                </div>
              </div>

              <div class="my-3 my-lg-4">
                <div class="w-100">
                  <slot name="before-add-to-basket"></slot>
                </div>

                <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                  {{ $translate("Ceres::Template.singleItemSetInfo") }}
                </div>
                <div v-else class="col-12 my-3 px-lg-0">
                  <add-to-basket
                    :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                    :has-price="currentVariation | hasItemDefaultPrice"
                    :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                    :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                    :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                    :item-url="currentVariation | itemURL"
                    :maximum-quantity="
                      !!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null
                    "
                    :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                    :order-properties="
                      currentVariation.properties.filter(function(prop) {
                        return prop.property.isOderProperty;
                      })
                    "
                    :has-order-properties="currentVariation.hasOrderProperties"
                    :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                    :use-large-scale="false"
                    :show-quantity="true"
                    :variation-id="currentVariation.variation.id"
                  >
                  </add-to-basket>
                </div>

                <div class="w-100 addition-btn">
                  <slot name="after-add-to-basket"></slot>
                </div>
              </div>

              <!-- ./ITEM DETAIL -->

              <slot name="additional-content-after-add-to-basket"></slot>

              <div v-if="currentVariation.texts.technicalData != ''">
                <div class="alert alert-warning my-4" v-html="currentVariation.texts.technicalData"></div>
              </div>

              <div class="mt-3 float-right">
                <span class="articlenumber text-muted">
                  <span>{{ $translate("babyVueTheme::Single.itemID") }}{{ currentVariation.variation.number }}</span>
                </span>
              </div>

              <slot name="additional-content-after-vat"></slot>
              <!-- END SINGLEITEM_DETAILS -->
            </div>
          </div>

          <div class="col-12 col-md-6 mb-3 mb-md-0">
            <!-- ITEM DESCRIPTION -->
            <div class="p-4 p-lg-5 singledescription">
              <p class="h4 font-weight-bold mb-4">{{ $translate("babyVueTheme::Single.productInformation") }} "{{ currentVariation | itemName }}"</p>
              <div class="" v-html="currentVariation.texts.description"></div>

              <div class="manufacturer" v-if="currentVariation.filter.hasManufacturer">
                <p class="h5 font-weight-bold mt-4">{{ $translate("babyVueTheme::Single.manufacturerHeadline") }}</p>

                <p class="mb-1 d-flex" v-if="currentVariation.item.manufacturer.responsibleName != ''">
                  <span class="manu-text mr-2">{{ $translate("babyVueTheme::Single.manufacturerName") }}</span
                  ><span>{{ currentVariation.item.manufacturer.responsibleName }}</span>
                </p>

                <p class="mb-1 d-flex" v-if="currentVariation.item.manufacturer.responsibleStreet != ''">
                  <span class="manu-text mr-2">{{ $translate("babyVueTheme::Single.manufacturerStreet") }}</span>
                  <span class="mr-1" v-if="currentVariation.item.manufacturer.responsibleStreet != ''">{{ currentVariation.item.manufacturer.responsibleStreet }}</span>
                  <span v-if="currentVariation.item.manufacturer.responsibleHouseNo != ''">{{ currentVariation.item.manufacturer.responsibleHouseNo }}</span>
                </p>

                <p class="mb-1 d-flex" v-if="currentVariation.item.manufacturer.responsiblePostCode != ''">
                  <span class="manu-text mr-2">{{ $translate("babyVueTheme::Single.manufacturerPlz") }}</span>
                  <span class="mr-1" v-if="currentVariation.item.manufacturer.responsiblePostCode != ''">{{ currentVariation.item.manufacturer.responsiblePostCode }}</span>
                  <span v-if="currentVariation.item.manufacturer.responsibleTown != ''">{{ currentVariation.item.manufacturer.responsibleTown }}</span>
                </p>

                <p class="mb-1 d-flex" v-for="country in currentVariation.item.manufacturer.responsibleCountryObject.names" v-if="country.language === 'de'">
                  <span class="manu-text mr-2">{{ $translate("babyVueTheme::Single.manufacturerCountry") }}</span>
                  <span>{{ country.name }}</span>
                </p>

                <p class="mb-1 d-flex" v-if="currentVariation.item.manufacturer.responsibleEmail != ''">
                  <span class="manu-text mr-2">{{ $translate("babyVueTheme::Single.manufacturerEmail") }}</span
                  ><a :href="'mailto:' + currentVariation.item.manufacturer.responsibleEmail">{{ currentVariation.item.manufacturer.responsibleEmail }}</a>
                </p>

                <p class="mb-1 d-flex" v-if="currentVariation.item.manufacturer.responsiblePhoneNo != ''">
                  <span class="manu-text mr-2">Telefon:</span>
                  <span>{{ currentVariation.item.manufacturer.responsiblePhoneNo }}</span>
                </p>

                <p class="mb-1 d-flex" v-if="currentVariation.item.manufacturer.responsibleContactUrl != ''">
                  <span class="manu-text mr-2">Kontakt:</span>
                  <a :href="currentVariation.item.manufacturer.responsibleContactUrl" rel="noopener" target="_blank">{{ currentVariation.item.manufacturer.responsibleContactUrl }}</a>
                </p>
              </div>
            </div>
            <!-- ./ITEM DESCRIPTION -->
          </div>

          <div class="col-12 col-md-6 col-lg-6 offset-xl-1 col-xl-5 bigimg mb-3 mb-md-0">
            <lazy-img v-if="hasProperty311 || hasDefaultImg1" :alt="currentVariation.texts.name1" :image-url="getPropertyImg(311, 1)" picture-class="img-fluid mt-5"></lazy-img>

            <lazy-img
              v-if="(hasProperty312 || hasDefaultImg2) && currentVariation.images.all.length > 1"
              :alt="currentVariation.texts.name1"
              :image-url="getPropertyImg(312, 2)"
              picture-class="img-fluid mt-5"
            ></lazy-img>
          </div>
        </div>
        <div class="fs-container-list">
          <slot name="item-list-container"></slot>
        </div>
        <slot name="feedback-container"></slot>
      </div>
    </slot>
  </div>
</template>

<script>
import { template } from "lodash";
import { get } from "../../helper/get";
import { isNullOrUndefined } from "../../helper/utils";

export default {
  name: "single-item",

  props: {
    pleaseSelectOptionVariationId: {
      type: Number,
      default: 0,
    },
    initPleaseSelectOption: {
      type: Boolean,
      default: false,
    },
    showNetPrices: {
      type: Boolean,
      default: false,
    },
    isWishListEnabled: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: Number,
      required: true,
    },
    afterKey: Object,
  },

  data() {
    return {
      propertyGroupList: [],
    };
  },

  jsonDataFields: ["itemData", "attributesData", "variations"],

  provide() {
    return {
      itemId: this.$props.itemId,
    };
  },

  computed: {
    itemConfig() {
      return App.config.item.itemData;
    },

    hasGroupId143() {
      if (this.currentVariation.variationProperties) {
        let propertiesArr = [];
        for (let propertyGroup of this.currentVariation.variationProperties) {
          propertiesArr = propertiesArr.concat(propertyGroup.properties);
        }
        this.propertyGroupList = propertiesArr.sort(function(a, b) {
          return a.position - b.position;
        });
        return true;
      }
      return false;
    },

    hasProperty311() {
      return this.hasPropertyId(311);
    },

    hasProperty312() {
      return this.hasPropertyId(312);
    },

    hasDefaultImg1() {
      return this.hasDefaultImgPosition(1);
    },

    hasDefaultImg2() {
      return this.hasDefaultImgPosition(2);
    },

    isDescriptionTabActive() {
      return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.description.length;
    },

    isManufacturerTabShown()
    {
    return (this.currentVariation.item.manufacturer.url !== "") ||
      (this.currentVariation.item.manufacturer.street !== "") ||
      (this.currentVariation.item.manufacturer.houseNo !== "") ||
      (this.currentVariation.item.manufacturer.postcode !== "") ||
      (this.currentVariation.item.manufacturer.town !== "") ||
      (this.currentVariation.item.manufacturer.countryId !== 0) ||
      (this.currentVariation.item.manufacturer.phoneNumber !== "") ||
      (this.currentVariation.item.manufacturer.faxNumber !== "") ||
      (this.currentVariation.item.manufacturer.email !== "") ||
      (this.currentVariation.item.manufacturer.legalName !== "") ||
      (this.currentVariation.item.manufacturer.contactUrl !== "") ||
      (this.currentVariation.item.manufacturer.name !== "") ||
      (this.currentVariation.item.manufacturer.externalName !== "");
    },
    isEuResponsibleTabShown()
    {
    return (this.currentVariation.item.manufacturer.responsibleEmail !== "") ||
      (this.currentVariation.item.manufacturer.responsibleHouseNo !== "") ||
      (this.currentVariation.item.manufacturer.responsibleName !== "") ||
      (this.currentVariation.item.manufacturer.responsiblePhoneNo !== "") ||
      (this.currentVariation.item.manufacturer.responsiblePostCode !== "") ||
      (this.currentVariation.item.manufacturer.responsibleStreet !== "") ||
      (this.currentVariation.item.manufacturer.responsibleTown !== "") ||
      (this.currentVariation.item.manufacturer.responsibleContactUrl !== "") ||
      (this.currentVariation.item.manufacturer.responsibleCountry !== 0);
    },

    isRecommendedPriceActive() {
      return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
    },

    isShortDescriptionActive() {
      return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
    },

    hasShippingCostsCategoryId() {
      return App.config.global.shippingCostsCategoryId > 0;
    },

    isTechnicalDataTabActive() {
      return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.technicalData.length;
    },

    variationGroupedProperties() {
      return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
    },

    variationMissingProperties() {
      return this.$store.getters[`${this.itemId}/variationMissingProperties`];
    },

    currentVariation() {
      return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
    },

    isVariationSelected() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
    },

    attributes() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
    },

    units() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
    },

    isItemSet() {
      return this.$store.state.items.isItemSet;
    },
  },

  created() {
    this.$store.dispatch("initVariation", this.itemData);
    this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
        itemId: this.itemId,
        attributes: this.attributesData,
        variations: this.variations,
        initialVariationId: this.currentVariation.variation.id,
        isPleaseSelectOption: this.initPleaseSelectOption,
        afterKey: this.afterKey,
      });

      if (this.isItemSet) {
        this.$store.dispatch("initSetComponents", this.itemData);
      }
    });

    // listen for variation change to hydrate all children lazy-hydrate components
    document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
  },

  methods: {
    getPropertyImg(propertyId, defaultUrl) {
      if (this.currentVariation.variationProperties) {
        for (let properties of this.currentVariation.variationProperties) {
          for (let property of properties.properties) {
            if (property.id === propertyId) {
              return property.values.value;
            }
          }
        }
      }
      if (this.hasDefaultImgPosition(defaultUrl)) {
        return this.currentVariation.images.all[defaultUrl].url;
      }
      return "";
    },

    hasPropertyId(propertyId) {
      if (this.currentVariation.variationProperties) {
        for (let properties of this.currentVariation.variationProperties) {
          for (let property of properties.properties) {
            if (property.id === propertyId) {
              return true;
            }
          }
        }
      }
      return false;
    },

    hasDefaultImgPosition(position) {
      return this.currentVariation.images && this.currentVariation.images.hasOwnProperty("all") && this.currentVariation.images.all.length > position;
    },

    getDataField(field) {
      return get(this.currentVariation, field);
    },

    getFilteredDataField(field, filter) {
      if (!isNullOrUndefined(this.$options.filters[filter])) {
        return this.$options.filters[filter](this.getDataField(field));
      }

      return this.getDataField(field);
    },

    // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
    hydrateChildren(nodes) {
      nodes.forEach((component) => {
        if (component.$options.name === "lazy-hydrate") {
          component.hydrate();
        } else if (component.$children.length) {
          this.hydrateChildren(component.$children);
        }
      });
    },
  },
};
</script>
